import SectionTitle from "@/components/base/SectionTitle";
import { testimonials } from "@/mocks/site";

export default function VoicesSection() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <SectionTitle
          eyebrow="Readers"
          title="读者怎么说"
          description="这些反馈来自读者来信与投稿，我们保留了原意，仅做了必要的隐私处理。"
        />

        <div className="mt-8 md:mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="h-full flex flex-col p-5 md:p-6 rounded-lg bg-background-50 border border-background-200"
            >
              <i className="ri-double-quotes-l text-2xl text-accent-500" aria-hidden="true"></i>
              <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700 flex-1">
                {item.quote}
              </blockquote>
              <figcaption className="mt-5 pt-4 border-t border-background-200 flex items-center gap-3">
                <span className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-200 text-secondary-900 font-heading text-sm font-bold shrink-0">
                  {item.name.slice(0, 1)}
                </span>
                <span className="min-w-0">
                  <span className="block text-sm font-medium text-foreground-900 truncate">
                    {item.name}
                  </span>
                  <span className="block text-xs text-foreground-500 truncate">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}